import { render, staticRenderFns } from "./investment-campaign-progress.vue?vue&type=template&id=184154c8&scoped=true"
import script from "./investment-campaign-progress.vue?vue&type=script&lang=js"
export * from "./investment-campaign-progress.vue?vue&type=script&lang=js"
import style0 from "./investment-campaign-progress.vue?vue&type=style&index=0&id=184154c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184154c8",
  null
  
)

export default component.exports